import { createContext, useContext, useEffect } from 'react';

// Réglages en cours d'essai dans un onglet de configuration (police essayée,
// style de tableau choisi dans la liste) : état local à l'onglet, que la page
// d'aperçu du Drawer (ConfigPagePreview) doit pourtant montrer. Hors du Drawer
// (pas de Provider), rien n'est partagé.
const ConfigPreviewContext = createContext(null);

export const ConfigPreviewProvider = ConfigPreviewContext.Provider;

export const useShareWithConfigPreview = (key, value) => {
  const setValues = useContext(ConfigPreviewContext);

  useEffect(() => {
    if (!setValues) return undefined;
    setValues((values) => ({ ...values, [key]: value }));
    return () => setValues(({ [key]: _removed, ...values }) => values);
  }, [setValues, key, value]);
};
